/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_In_Reason_From_ProcessInputs */

const vi_scl_in_reason_from_process = /** @type {(inputs: Scl_In_Reason_From_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ phiếu xuất lô phân loại`)
};

/**

* @param {Scl_In_Reason_From_ProcessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_in_reason_from_process = /** @type {((inputs?: Scl_In_Reason_From_ProcessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_In_Reason_From_ProcessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_in_reason_from_process(inputs)
});